'use client';
import { jsx as l, jsxs as v } from "react/jsx-runtime";
import { useOnClickOutside as R, cn as _ } from "@tameeni/shared-logic";
import S, { useState as O, useRef as b } from "react";
import j, { components as D } from "react-select";
import { Icon as E } from "@tameeni/icons";
import { CustomInput as F, CustomOption as z, getClassNames as H } from "./components.js";
const K = S.forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (h, M) => {
    const {
      value: s,
      options: o,
      className: N,
      onChange: n,
      onClear: i,
      placeholder: I,
      isInvalid: k = !1,
      isDisabled: y,
      isLoading: C,
      isSearchable: g,
      listHeading: a,
      // Extract our custom props
      ...r
      // All remaining props will be passed to ReactSelect
    } = h, [x, u] = O(s && s.length > 0), [m, t] = O(!1), p = b(null);
    R(p, () => t(!1));
    const d = S.useMemo(() => o.filter((e) => s == null ? void 0 : s.includes(e.value)), [s, o]);
    return /* @__PURE__ */ l(
      "div",
      {
        ref: p,
        onClick: () => t(!0),
        className: _(N),
        children: /* @__PURE__ */ l(
          j,
          {
            menuIsOpen: m,
            onFocus: () => t(!0),
            onKeyDown: (e) => {
              e.key === "Escape" && t(!1), (e.key === "Enter" || e.key === " ") && t(!0);
            },
            options: o,
            unstyled: !0,
            ref: M,
            value: d,
            noOptionsMessage: () => "No options",
            placeholder: I || "",
            closeMenuOnSelect: !1,
            hideSelectedOptions: !1,
            isMulti: !0,
            isClearable: !0,
            menuShouldScrollIntoView: !0,
            openMenuOnFocus: !0,
            isDisabled: y,
            isLoading: C,
            isSearchable: g,
            onChange: (e, f) => {
              f.action === "clear" ? i == null || i() : e && (n == null || n(
                e.map(
                  (c) => c.value
                )
              ), (e == null ? void 0 : e.length) > 0 ? u(!0) : u(!1));
            },
            classNames: H({
              isInvalid: k,
              isMenuOpened: m,
              isSelected: !1
            }),
            components: {
              Option: z,
              Input: F,
              Menu: ({ children: e, className: f, ...c }) => /* @__PURE__ */ v(D.Menu, { ...c, children: [
                a && /* @__PURE__ */ l("div", { className: "text-sm font-semibold text-slate-400 px-3 py-2", children: a }),
                e
              ] }),
              ClearIndicator: () => x && /* @__PURE__ */ l(E, { name: "CheckCircle", className: "size-4 text-green" }),
              ...r.components
            },
            ...r
          },
          `react_select_key_${d.map((e) => e.value).join(",")}`
        )
      }
    );
  }
);
K.displayName = "MultiSelect";
export {
  K as MultiSelect
};
